
import React from "react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { UserMinus, UserPlus } from "lucide-react";
import type { UserWithSubscription } from "./adminUserUtils";

interface UserTableRowProps {
  user: UserWithSubscription;
  onActivate: (userId: string) => void;
  onDeactivate: (subscriptionId: string) => void;
  activating: boolean;
  deactivating: boolean;
  isLast?: boolean;
  rowIndex?: number;
}

const UserTableRow: React.FC<UserTableRowProps> = ({
  user,
  onActivate,
  onDeactivate,
  activating,
  deactivating,
  isLast = false,
  rowIndex = 0,
}) => {
  return (
    <tr
      className={[
        rowIndex % 2 === 0 ? "bg-white" : "bg-gray-50",
        !isLast ? "border-b border-gray-200" : "",
        "hover:bg-muted/80 transition-colors"
      ].join(" ")}
    >
      <td className="py-4 px-6 align-middle">
        <div>
          <div className="font-medium">{user.full_name || "N/A"}</div>
          <div className="text-xs text-gray-500">
            Joined {new Date(user.created_at).toLocaleDateString()}
          </div>
        </div>
      </td>
      <td className="py-4 px-6 align-middle">{user.email}</td>
      <td className="py-4 px-6 align-middle">
        {user.subscription ? (
          <div>
            <div className="font-medium capitalize">{user.subscription.plan}</div>
            <div className="text-xs text-gray-500">
              ${user.subscription.amount}/month
            </div>
          </div>
        ) : (
          <span className="text-gray-400 text-xs">No subscription</span>
        )}
      </td>
      <td className="py-4 px-6 align-middle">
        {user.subscription ? (
          <Badge variant={user.subscription.status === 'active' ? 'default' : 'secondary'}>
            {user.subscription.status}
          </Badge>
        ) : (
          <Badge variant="outline">Free</Badge>
        )}
      </td>
      <td className="py-4 px-6 align-middle">
        <div className="flex gap-2">
          {user.subscription?.status === "active" ? (
            <Button
              variant="destructive"
              size="sm"
              onClick={() => onDeactivate(user.subscription!.id)}
              disabled={deactivating}
            >
              <UserMinus className="h-4 w-4 mr-1" />
              Deactivate
            </Button>
          ) : (
            <Button
              variant="default"
              size="sm"
              onClick={() => onActivate(user.id)}
              disabled={activating}
            >
              <UserPlus className="h-4 w-4 mr-1" />
              Activate
            </Button>
          )}
        </div>
      </td>
    </tr>
  );
};

export default UserTableRow;

